import './style/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';

const root = createRoot(document.getElementById('root'));

const domain = "dev-je48ucjlmgdqug6a.us.auth0.com";
const clientId = "CZPuOV2izCVkLvGbxfOQ2gjGVISwkcO8";
const audience = "https://tilsubscribe_api/"; 

root.render(
  <Auth0Provider
  domain={process.env.REACT_APP_AUTH0_DOMAIN}
  clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
  authorizationParams={{
    redirect_uri: process.env.REACT_APP_AUTH0_REDIRECT_URI,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  }}
>
  <App />
</Auth0Provider>

);

reportWebVitals();


